import { Link } from 'react-router-dom';
import styles from './Logo.module.css';

interface LogoProps {
  linkTo?: string;
}

export const Logo = ({ linkTo = '/' }: LogoProps) => {
  return (
    <Link to={linkTo} className={styles.logo}>
      <div className={styles.logoMark}>
        <svg viewBox="0 0 24 24">
          <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
          <line x1="8" y1="9" x2="16" y2="9" strokeWidth="1.5" stroke="currentColor"/>
          <line x1="8" y1="13" x2="13" y2="13" strokeWidth="1.5" stroke="currentColor"/>
        </svg>
      </div>
      <span className={styles.logoText}>Solo Sense</span>
    </Link>
  );
};
